var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',_vm._g(_vm._b({},'v-list-item',_vm.$attrs,false),_vm.$listeners),[(_vm.$slots.icon)?_c('v-list-item-icon',{staticClass:"ma-0 mt-2 ml-3"},[_c('v-icon',[_vm._t("icon")],2)],1):_vm._e(),_c('v-list-item-content',[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }